import { useMutation } from '@tanstack/react-query'

import { openBijlageForEntity } from '../services/openBijlageForEntity'

export { useOpenBijlageForEntity }

const useOpenBijlageForEntity = () => {
  return useMutation({
    mutationFn: openBijlageForEntity,
  })
}
